import React, { useState } from "react";
import Image from "../../../components/AppImage";

const TechnologyGrid = ({ technologies }) => {
  const [hoveredTech, setHoveredTech] = useState(null);

  const getSkillLevelColor = (level) => {
    switch (level) {
      case "basic":
        return "bg-slate-100 text-slate-700";
      case "intermediate":
        return "bg-primary-100 text-primary-700";
      case "expert":
        return "bg-primary-600 text-white";
      default:
        return "bg-slate-100 text-slate-700";
    }
  };

  const getSkillLevelLabel = (level) => {
    switch (level) {
      case "basic":
        return "Basic";
      case "intermediate":
        return "Intermediate";
      case "expert":
        return "Expert";
      default:
        return "Basic";
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
      {technologies.map((tech) => (
        <div
          key={tech.id}
          className="relative flex flex-col items-center p-4 rounded-lg border border-slate-200 bg-white shadow-sm hover:shadow-md transition-all duration-200"
          onMouseEnter={() => setHoveredTech(tech.id)}
          onMouseLeave={() => setHoveredTech(null)}
          onFocus={() => setHoveredTech(tech.id)}
          onBlur={() => setHoveredTech(null)}
          tabIndex="0"
        >
          <div className="w-16 h-16 mb-4 flex items-center justify-center">
            <Image
              src={tech.logo}
              alt={`${tech.name} logo`}
              className="max-w-full max-h-full object-contain"
            />
          </div>
          <h3 className="text-center text-sm font-medium text-slate-900">
            {tech.name}
          </h3>
          
          {/* Skill level badge */}
          <div
            className={`absolute top-2 right-2 px-2 py-1 text-xs font-medium rounded-full transition-opacity duration-200 ${
              getSkillLevelColor(tech.skillLevel)
            } ${hoveredTech === tech.id ? "opacity-100" : "opacity-0"}`}
            aria-hidden={hoveredTech !== tech.id}
          >
            {getSkillLevelLabel(tech.skillLevel)}
          </div>
          
          {/* Technology description tooltip */}
          <div
            className={`absolute z-10 bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 p-2 bg-slate-800 text-white text-xs rounded shadow-lg transition-opacity duration-200 ${
              hoveredTech === tech.id ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
            aria-hidden={hoveredTech !== tech.id}
          >
            {tech.description}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-slate-800"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TechnologyGrid;